import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { RecertFormData } from 'components/Assessments/RecertAssessment/types/RecertFormData'
import { RecertFormField } from 'components/Assessments/RecertAssessment/types/RecertFormField'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { RecertAssessmentQuestionnaireItem } from 'components/Assessments/RecertAssessment/types/questionnaire'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'

/**
 * Musculoskeletal subsection adapter
 * Handles musculoskeletal system assessment (2 fields - simplest after Lines/Drains)
 */
export class MusculoskeletalAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Musculoskeletal assessment fields
    const musculoskeletalAssessment = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT
    )

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [RecertFormField.MUSCULOSKELETAL_ASSESSMENT]: musculoskeletalAssessment,
      [RecertFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RecertFormField.MUSCULOSKELETAL_ASSESSMENT)) {
      mutations.push({
        linkId:
          RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT,
        value: this.getFormDataField(RecertFormField.MUSCULOSKELETAL_ASSESSMENT)
      })
    }

    if (this.formDataFieldExists(RecertFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY,
        value: this.getFormDataField(RecertFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
